import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_M, BUTTON_VARIANT_OUTLINE } from './config';

export const ButtonSecondary = ({
  disabled,
  variant = BUTTON_VARIANT_M,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      className={classNames(className, {
        'text-primary fill-tertiary focus:fill-tertiary-active': !disabled && variant !== BUTTON_VARIANT_OUTLINE,
        'text-primary hover:text-secondary bg-transparent focus:bg-transparent focus:text-secondary':
          variant === BUTTON_VARIANT_OUTLINE && !disabled,
        'fill-tertiary-disabled text-transparent-20': disabled,
      })}
      borderClasses={classNames({
        'border-0': variant !== BUTTON_VARIANT_OUTLINE || disabled,
        'border border-negative': variant === BUTTON_VARIANT_OUTLINE && !disabled,
      })}
      {...props}
      variant={variant}>
      {children}
    </Button>
  );
};
